var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialEconomicData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 359.162V512h30V359.162c10.399-1.155 20.445-3.495 30-6.884V450h332V98.787L413.213 0H180v97.722C165.918 92.728 150.773 90 135 90 60.561 90 0 150.561 0 225c0 69.369 52.594 126.676 120 134.162zM422 51.213 460.787 90H422zM210 30h182v90h90v300H210v-82.806c36.154-24.247 60-65.487 60-112.194s-23.846-87.947-60-112.194zm-75 90c57.897 0 105 47.103 105 105s-47.103 105-105 105S30 282.897 30 225s47.103-105 105-105z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 210h30v60H60zM120 150h30v120h-30zM180 180h30v90h-30zM317 180h120v30H317zM302 240h135v30H302zM287 300h150v30H287z",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEconomicData);
export default __webpack_public_path__ + "static/media/social-economic-data.b51bcb96cc70d6b0436e3a79fb3f0880.svg";
export { ForwardRef as ReactComponent };